import { BATCH } from 'redux-batched-actions';
import {
	BACKLOG_VIEW,
	LOAD_APP_DATA_FAILURE,
	LOAD_CONFIG_DATA_FAILURE,
	REFRESH_DATA_REQUEST,
	LOAD_CONFIG_DATA_SUCCESS,
	LOAD_CONFIG_DATA_MODEL_SUCCESS,
	LOAD_CARD_CREATE_CONFIG_SUCCESS,
	LOAD_CARD_CREATE_CONFIG_FAILURE,
} from '../../actions/app';
import {
	BOARD_ISSUE_MOVE_CANCEL,
	BOARD_ISSUE_MOVE_EXECUTE,
	BOARD_ISSUE_MOVE_EXECUTE_FAILURE,
	BOARD_ISSUE_MOVE_EXECUTE_SUCCESS,
	BOARD_ISSUE_MOVE_SHOW,
} from '../../actions/board-issue-move';
import {
	CARD_CREATE_FAILURE,
	CARD_CREATE_SUCCESS,
	CARD_CREATE_MULTIPLE_REQUEST,
	CARD_CREATE_FILTERED,
	CARD_CREATE_FILTERED_V2,
} from '../../actions/cards/create';
import {
	CARD_DELETE_FAILURE,
	CARD_DELETE_REQUEST,
	CARD_DELETE_SUCCESS,
} from '../../actions/cards/delete';
import {
	FILTERED_CARD_SUCCESS,
	FILTERED_CARD_FAILURE,
	REFILTER_SUCCESS,
	REFILTER_FAILURE,
	FILTERED_CARD_CLEAR_SUCCESS,
	FILTERED_CARD_CLEAR_FAILURE,
} from '../../actions/cards/filtered-cards';
import {
	CARDS_FLAG_WITH_COMMENT_FAILURE,
	CARDS_FLAG_WITH_COMMENT_REQUEST,
	CARDS_FLAG_WITH_COMMENT_SUCCESS,
} from '../../actions/cards/flag-with-comment';
import { CARDS_MOVE, CARDS_MOVE_FAILURE, CARDS_MOVE_SUCCESS } from '../../actions/cards/move';
import { CARDS_PARENT_SET_SUCCESS, CARDS_PARENT_SET_FAILURE } from '../../actions/cards/parent';
import { CARD_CLICK } from '../../actions/cards/selection';
import { OPEN_DETAIL_VIEW } from '../../actions/detail-view';
import { SET_ALL_FILTERS } from '../../actions/filters';
import {
	SPRINT_CREATE_REQUEST,
	SPRINT_CREATE_SUCCESS,
	SPRINT_CREATE_FAILURE,
} from '../../actions/sprints/create';
import { SPRINT_DELETE_REQUEST, SPRINT_DELETE_SUCCESS } from '../../actions/sprints/delete';
import {
	backlogLoadAppDataFailure,
	backlogLoadConfigDataFailure,
	backlogView,
	refreshDataRequest,
	backlogLoadConfigDataSuccess,
} from './app';
import {
	boardIssueMoveCancel,
	boardIssueMoveExecute,
	boardIssueMoveExecuteSuccess,
	boardIssueMoveExecuteFailure,
	boardIssueMoveShow,
} from './board-issue-move';
import {
	cardCreateSuccess,
	cardCreateFailure,
	cardCreateFiltered,
	cardCreateFilteredV2,
	cardDeleteSuccess,
	cardDeleteFailure,
	cardsFlagSuccess,
	cardsFlagFailure,
	cardOpenDetailView,
	cardCreateSuccessPerformance,
	cardsMoveSuccess,
	cardsMoveFailure,
	cardRankRequestPerformance,
	cardDeleteRequestPerformance,
	cardsFlagRequestPerformance,
	cardsParentSetSuccess,
	cardsParentSetFailure,
	cardCreateMultipleRequestPerformance,
} from './card';
import { setCardRequestIndividualResponse } from './card-set-request';
import {
	setCustomFiltersPerformance,
	setCustomFiltersFailure,
	setCustomFiltersSuccess,
	setCustomFiltersRefilterFailure,
	setCustomFiltersRefilterSuccess,
	setClearCustomFiltersPerformance,
	setClearCustomFiltersSuccess,
	setClearCustomFiltersFailure,
} from './custom-filter';
import { setAllFilters, setAllFiltersPerformance } from './filter';
import { issueViewOpenPerformance } from './issue-view';
import { cardCreateConfigLoadFailure, cardCreateConfigLoadSuccess } from './load-card-config';
import {
	sprintCreateRequestPerformance,
	sprintCreateSuccessPerformance,
	sprintDeleteRequestPerformance,
	sprintDeleteSuccessPerformance,
	sprintCreateSuccess,
	sprintCreateFailure,
} from './sprint';
import type { AnalyticsActionsMap } from './types';

export const ANALYTIC_PREFIX = 'plan-view';

const actionAnalyticsMap = () =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	({
		[BACKLOG_VIEW]: [backlogView],

		[LOAD_APP_DATA_FAILURE]: [backlogLoadAppDataFailure],
		[LOAD_CONFIG_DATA_FAILURE]: [backlogLoadConfigDataFailure],
		[LOAD_CONFIG_DATA_SUCCESS]: [backlogLoadConfigDataSuccess],
		[LOAD_CONFIG_DATA_MODEL_SUCCESS]: [backlogLoadConfigDataSuccess],

		[REFRESH_DATA_REQUEST]: [refreshDataRequest],

		[BOARD_ISSUE_MOVE_SHOW]: [boardIssueMoveShow],
		[BOARD_ISSUE_MOVE_CANCEL]: [boardIssueMoveCancel],
		[BOARD_ISSUE_MOVE_EXECUTE]: [boardIssueMoveExecute],
		[BOARD_ISSUE_MOVE_EXECUTE_FAILURE]: [boardIssueMoveExecuteFailure],
		[BOARD_ISSUE_MOVE_EXECUTE_SUCCESS]: [boardIssueMoveExecuteSuccess],

		[CARD_CREATE_MULTIPLE_REQUEST]: [cardCreateMultipleRequestPerformance],
		[CARD_CREATE_SUCCESS]: [cardCreateSuccess, cardCreateSuccessPerformance],
		[CARD_CREATE_FAILURE]: [cardCreateFailure],
		[CARD_CREATE_FILTERED]: [cardCreateFiltered],
		[CARD_CREATE_FILTERED_V2]: [cardCreateFilteredV2],

		[CARD_DELETE_REQUEST]: [cardDeleteRequestPerformance],
		[CARD_DELETE_SUCCESS]: [cardDeleteSuccess],
		[CARD_DELETE_FAILURE]: [cardDeleteFailure],

		[CARDS_FLAG_WITH_COMMENT_REQUEST]: [cardsFlagRequestPerformance],
		[CARDS_FLAG_WITH_COMMENT_SUCCESS]: [cardsFlagSuccess],
		[CARDS_FLAG_WITH_COMMENT_FAILURE]: [cardsFlagFailure],

		[CARDS_PARENT_SET_SUCCESS]: [cardsParentSetSuccess],
		[CARDS_PARENT_SET_FAILURE]: [cardsParentSetFailure],

		[SET_ALL_FILTERS]: [setAllFilters, setAllFiltersPerformance],

		[OPEN_DETAIL_VIEW]: [cardOpenDetailView],
		[CARDS_MOVE]: [cardRankRequestPerformance],
		[CARDS_MOVE_SUCCESS]: [cardsMoveSuccess],
		[CARDS_MOVE_FAILURE]: [cardsMoveFailure],
		[SPRINT_CREATE_REQUEST]: [sprintCreateRequestPerformance],
		[SPRINT_CREATE_SUCCESS]: [sprintCreateSuccess, sprintCreateSuccessPerformance],
		[SPRINT_CREATE_FAILURE]: [sprintCreateFailure],

		[SPRINT_DELETE_REQUEST]: [sprintDeleteRequestPerformance],
		[SPRINT_DELETE_SUCCESS]: [sprintDeleteSuccessPerformance],

		[CARD_CLICK]: [issueViewOpenPerformance],

		[FILTERED_CARD_SUCCESS]: [setCustomFiltersPerformance, setCustomFiltersSuccess],
		[FILTERED_CARD_FAILURE]: [setCustomFiltersFailure],
		[REFILTER_SUCCESS]: [setCustomFiltersRefilterSuccess],
		[REFILTER_FAILURE]: [setCustomFiltersRefilterFailure],
		[FILTERED_CARD_CLEAR_SUCCESS]: [setClearCustomFiltersPerformance, setClearCustomFiltersSuccess],
		[FILTERED_CARD_CLEAR_FAILURE]: [setClearCustomFiltersFailure],
		[BATCH]: [setCardRequestIndividualResponse],

		[LOAD_CARD_CREATE_CONFIG_SUCCESS]: [cardCreateConfigLoadSuccess],
		[LOAD_CARD_CREATE_CONFIG_FAILURE]: [cardCreateConfigLoadFailure],
	}) as AnalyticsActionsMap;

export default actionAnalyticsMap;
